import { render, staticRenderFns } from "./AuthTextButton.vue?vue&type=template&id=45ff0930&scoped=true&"
import script from "./AuthTextButton.vue?vue&type=script&lang=js&"
export * from "./AuthTextButton.vue?vue&type=script&lang=js&"
import style0 from "./AuthTextButton.vue?vue&type=style&index=0&id=45ff0930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff0930",
  null
  
)

export default component.exports